import { render, staticRenderFns } from "./pagingfy.vue?vue&type=template&id=58995aa1&"
import script from "./pagingfy.vue?vue&type=script&lang=js&"
export * from "./pagingfy.vue?vue&type=script&lang=js&"
import style0 from "./pagingfy.vue?vue&type=style&index=0&id=58995aa1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports